<template>
  <div class='mine-studentMessage-grade-gradeAdd'>
    <div class="contentBox">
      <p class="subject">
        {{data.gradeName}}-{{data.nameName}}
      </p>
      <p class="totalScore">总分：{{data.totalScore}}</p>
      <table class="gradeTable">
        <thead>
          <tr style="background:#F0F9FE "></tr>
          <th width='130'>科目</th>
          <th width='100'>分数</th>
          <th width='100'>年级人数</th>
          <th width='100'>单科排名</th>
          <th width='120'>年级总排名</th>
          <th>考试说明</th>
        </thead>
        <tbody>
          <tr v-for="(item,index) in data.subject" :key="index">
            <td style="background:#FAFDFF ">{{item.subject}}</td>
            <td>{{item.score}}</td>
            <td>{{item.totalPeople}}</td>
            <td>{{item.rank}}/{{item.totalPeople}}</td>
            <td v-if="index==0" :rowspan="data.subject.length">
              {{data.totalRank}}/{{data.totalPeople}}
            </td>
            <td>
              <p style="display: flex;align-items: center;line-height: 24px;justify-content: center;padding: 0 10px">
                {{item.remark}}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="summary">
        <SummaryTitle title="考试总结"></SummaryTitle>
        <el-input type="textarea"  :value="data.remark" disabled></el-input>
      </div>
      <div class="point">
        <p class="title">下一阶段重点提升学科</p>
        <p class="detial">
          <span v-for="(item,index) in data.subject||[]" :key="index" v-if="item.important==1">{{item.subject}}、</span>
        </p>
      </div>
    </div>
    <div v-if="!getDatas" :style="{display:'flex',justifyContent:'space-between',width:$route.query.length==4?'100px':'300px',margin:'40px auto'}">
      <Button name="返回" @handleClick="$router.go(-1)"></Button>
      <template v-if="$route.query.length!=4">
        <Button name="添加行动计划" @handleClick="$router.push({path:'/consultant/minestudent/main/implement/actionplan/add',query:$route.query})"></Button>
      </template>
    </div>
  </div>
</template>
<script>
import SummaryTitle from "@/components/xueyezixun/SummaryTitle";
import Button from "@/components/xueyezixun/Button";

export default {
  components:{SummaryTitle,Button},
  props:['id','getDatas'],
  data() {
    return {
      data:{},
      ids:''
    }
  },
  methods: {
    getData(){
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.grade.detailAchievement, {
        id:this.$route.query.gradeDetailId
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
          this.data=res.data.data
          if(this.getDatas){
            this.getDatas(this.data)
          }
        }else{

        }
      })
    },
  },
  mounted() {
    this.getData()
  }
}
</script>
<style scoped lang="less">
  @import "./css/gradeAdd.less";
  @import "./css/index.less";
  /deep/ .button{
    padding:0 30px;
  }
</style>